module.exports = __webpack_public_path__ + "img/register-v2-dark.a3e7fd70.svg";